var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseCustom = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F50",
    fillRule: "evenodd",
    d: "M8 14.667c3.682 0 6.667-2.985 6.667-6.667S11.682 1.333 8 1.333 1.333 4.318 1.333 8 4.318 14.667 8 14.667zm2.354-9.02c.195.195.195.511 0 .707L8.707 8l1.647 1.646c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L8 8.707l-1.646 1.647c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L7.293 8 5.646 6.354c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L8 7.293l1.646-1.647c.196-.195.512-.195.708 0z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCustom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/closeCustom.2f0ccc31.svg";
export { ForwardRef as ReactComponent };